/**
 * Utilidades para validación de claves de reembolso
 */

/**
 * Valida si una cadena cumple con los requisitos de seguridad para clave de reembolso
 * @param str - La cadena a validar (texto plano)
 * @returns true si cumple requisitos de seguridad, false en caso contrario
 */
export const isValidRefundCode = (str: string): boolean =>
{
    if(!str || str.trim() === "")
    {
        return false;
    }

    const trimmedStr = str.trim();
    
    // Verificar longitud (12-30 caracteres)
    if(trimmedStr.length < 12 || trimmedStr.length > 30)
    {
        return false;
    }

    // Al menos una mayúscula
    if(!/[A-Z]/.test(trimmedStr))
    {
        return false;
    }

    // Al menos una minúscula
    if(!/[a-z]/.test(trimmedStr))
    {
        return false;
    }

    // Al menos un carácter especial
    if(!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(trimmedStr))
    {
        return false;
    }

    // Al menos un número
    if(!/[0-9]/.test(trimmedStr))
    {
        return false;
    }

    return true;
};

/**
 * Obtiene el mensaje de error específico para una clave de reembolso
 * @param str - La cadena a validar (texto plano)
 * @returns Mensaje de error específico o cadena vacía si es válida
 */
export const getRefundCodeErrorMessage = (str: string): string =>
{
    if(!str || str.trim() === "")
    {
        return "Debe establecer primero su Clave de Reembolso.";
    }
    
    const trimmedStr = str.trim();
    
    if(trimmedStr.length < 12)
    {
        return "La Clave de Reembolso debe tener al menos 12 caracteres.";
    }
    
    if(trimmedStr.length > 30)
    {
        return "La Clave de Reembolso debe tener como máximo 30 caracteres.";
    }

    // Al menos una mayúscula
    if(!/[A-Z]/.test(trimmedStr))
    {
        return "La Clave de Reembolso debe contener al menos una letra mayúscula.";
    }

    // Al menos una minúscula
    if(!/[a-z]/.test(trimmedStr))
    {
        return "La Clave de Reembolso debe contener al menos una letra minúscula.";
    }

    // Al menos un carácter especial
    if(!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(trimmedStr))
    {
        return "La Clave de Reembolso debe contener al menos un carácter especial.";
    }

    // Al menos un número
    if(!/[0-9]/.test(trimmedStr))
    {
        return "La Clave de Reembolso debe contener al menos un número.";
    }
    
    return "";
};
